"use client";

import { Button } from "@/components";

interface AuthButtonsProps {
    onLoginClick: () => void;
    onRegisterClick: () => void;
    className?: string;
}

const AuthButtons: React.FC<AuthButtonsProps> = ({
    onLoginClick,
    onRegisterClick,
    className = "",
}) => {
    const baseButtonClasses = "btn-raleway bg-white text-black hover:bg-light-grey py-4 px-6 !min-w-0 !w-auto";
    const loginButtonClasses = `${baseButtonClasses} border-black`;
    const registerButtonClasses = `${baseButtonClasses} !border-none`;

    return (
        <div className={`flex flex-col sm:flex-row gap-3 sm:gap-4 ${className}`}>
            <Button
                className={loginButtonClasses}
                onClick={onLoginClick}
            >LOGIN</Button>
            <Button
                className={registerButtonClasses}
                onClick={onRegisterClick}
            >REGISTER</Button>
        </div>
    );
};

export default AuthButtons; 